import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, OnInit, Inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from 'src/app/services/toast.service';
import { CustomObject } from 'src/app/models/customObject.model';
import { CustomObjectService } from 'src/app/services/customObject.service';
import { IconList } from 'src/app/shared/iconList';

@Component({
  standalone: false,
    selector: 'app-edit-custom-object-dialog',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: 'editCustomObjectDialog.component.html',
})
export class EditCustomObjectDialogComponent implements OnInit, OnDestroy {

    isFormLoading = false;
    isLoading = false;
    customObject: CustomObject;
    icons: string[] = [];

    constructor(public dialogRef: MatDialogRef<EditCustomObjectDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CustomObject,
        private customObjectService: CustomObjectService,
        private toastService: ToastService
    ) {
        this.customObject = new CustomObject();
        this.icons.push(...IconList.icons.map(x => x.value));
    }

    ngOnInit() {
        this.isFormLoading = true;
        this.customObjectService.getById(this.data.id)
            .subscribe({
                next: (result) => {
                    this.customObject = result;
                    this.isFormLoading = false;
                },
                error: (error) => {
                    this.toastService.showError(error);
                    this.isFormLoading = false;
                }
            });
    }

    save() {
        this.isLoading = true;
        this.customObjectService.update(this.customObject)
            .subscribe({
                next: () => {
                    this.isLoading = false;
                    this.toastService.showSuccess('{{typeName}} saved successfully', true, {typeName: this.data.typeName});
                    this.dialogRef.close(true);
                },
                error: (error) => {
                    this.isLoading = false;
                    this.toastService.showError(error);
                }
            });
    }

    public trackByIndex = trackByIndex;

    ngOnDestroy() {
    }
}
